import { render, staticRenderFns } from "./SortableCards.vue?vue&type=template&id=4ba74891&"
import script from "./SortableCards.vue?vue&type=script&lang=ts&"
export * from "./SortableCards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports